import { DevServerBanner } from "@/components/dev/dev-server-banner";
import { Toaster } from "@/components/ui/sonner";
import { PosthogProvider } from "@/features/analytics/modules/posthog/posthog-provider";
import { CookieConsentProvider } from "@/features/cookies/modules/cookie-consent/cookie-consent-provider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      {/* Toaster first so it subscribes to Sonner before the rest of the tree
          mounts; otherwise a toast fired in a child's mount effect (e.g. the
          OAuth error on the login page) is dropped before the Toaster listens. */}
      <Toaster />
      <DevServerBanner />
      <CookieConsentProvider />
      <PosthogProvider />
      {children}
    </>
  );
}
